import {cacheWrapper, isDev} from "@/components/DownloaderApp/utils";
import {getLicenseKey} from "@/components/DownloaderApp/usePremium";
import {queryClient} from "@/components/DownloaderApp/queryClient";
import {isKickStreamUrl} from "@/components/DownloaderApp/platform-detection";
import type {Video2} from "@/utils/kick-video";


// if(typeof window !== 'undefined') {
//     window.call = async function () {
//         return queryClient.fetchQuery({
//             queryKey: ['test-fetch'],
//             queryFn: async () => {
//                 try {
//                     const response = await fetch('https://www.twitch.tv/videos/2197602166');
//                     console.log({response})
//                     if (!response.ok) {
//                         throw new Error('Network response was not ok');
//                     }
//                     return response.json()
//                 }catch (error) {
//                     console.error({error})
//                     throw new Error('craigbryant@mailinator.com@');
//                 }
//             }
//         })
//     }
// }


async function decentFetch(url) {
    let response;
    try {
        response = await fetch(url)
    } catch (err) {
        throw new SevereContentDetailsError("(SevereContentDetailsError) Cant get video > " + url + " > " + err.toString())
    }
    console.log(response)
    if (!response.ok) {
        throw new ContentDetailsError(response.status + "(ContentDetailsError) Cant get video > " + url, response.status, response);
    }
    return response;
}

export function buildKickClipApiUrl(id) {
    return `https://kick.com/api/v2/clips/clip_${id}`
}

async function _getKickClip(id = '01HNVAXTQ661HBNBXV3X75707C') {
    const url = buildKickClipApiUrl(id);

    let videoStr = await decentFetchWithProxy(url);

    videoStr = await videoStr.text()
    return JSON.parse(videoStr).clip;
}

async function _getKickLivestream(id = 'wariatp2w') {

    // let videoStr = await decentFetchWithProxy(`https://kick.com/api/v2/channels/${id}`);
    let videoStr = await decentFetchWithProxy(`https://kick.com/api/v1/channels/${id}`);

    videoStr = await videoStr.text()
    return JSON.parse(videoStr);
}

export class ContentDetailsError extends Error {
    constructor(message, status, response) {
        super(message);
        this.name = "ContentDetailsError";
        this.status = status;
        this.response = response;
    }
}

export class SevereContentDetailsError extends Error {
    constructor(message) {
        super(message);
        this.name = "SevereContentDetailsError";
    }
}

export function buildKickVodApiUrl(id) {
    return "https://kick.com/api/v1/video/" + id
}

function track(eventName, props) {
    try {
        window.posthog?.capture(eventName, props)
    } catch (err) {
    }
}

async function decentFetchWithProxy(url: string) {
    let videoStr
    try {
        videoStr = await decentFetch(url)
        console.log('decentFetch', url, videoStr)
    } catch (err) {
        if (err instanceof SevereContentDetailsError) {
            // track('[SevereContentDetailsError] start')
            let response = '';
            try {
                videoStr = await fetch(`/api/get-kick-video?url=${url}`)
                const text = await videoStr.text();
                JSON.parse(text)
                return {
                    text() {
                        return text
                    }
                }
            } catch (_err) {
                // track('[SevereContentDetailsError] fail', {response})
                console.log('decentFetchWithProxy:err', _err)
                throw err;
            }
            // track('[SevereContentDetailsError] success', {response})
        } else {
            throw err;
        }
    }
    return videoStr;
}

async function _getKickVod(id) {
    const url = buildKickVodApiUrl(id);

    let videoStr = await decentFetchWithProxy(url)
    console.log('decentFetchWithProxy: ', videoStr)

    // if(isDev) throw new SevereContentDetailsError();

    videoStr = await videoStr.text()
    return JSON.parse(videoStr);
}

async function _getKickClips(channel = 'channel') {
    let videoStr = await decentFetchWithProxy(`https://kick.com/api/v2/channels/${channel}/clips`)

    videoStr = await videoStr.text()
    return JSON.parse(videoStr);
}

export function buildUrlWithParams(pathname: string, params: Record<string, string | boolean | undefined>): string {
    const url = new URL(pathname, window.location.origin);
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
            url.searchParams.append(key, String(value));
        }
    });
    return url.toString();
}

async function _getKickPremiumVod(config) {
    return await fetch(buildUrlWithParams('/api/get-premium-content-2', config), {
        headers: {
            'X-License-Key': getLicenseKey() || '',
        },
    }).then(a => a.json())
}

export interface KickVod2Response {
    video2?: Video2;
    error?: string;
    output?: null;
}

export interface KickVod2Result {
    json: KickVod2Response | null;
    ok: boolean;
    status: number;
}

export async function getKickVod2(videoUrl: string, channelId: number|null): Promise<KickVod2Result> {
    const endpoint = isKickStreamUrl(videoUrl) ? 'get-kick-video-by-stream' : 'get-kick-video2';
    return queryClient.fetchQuery<KickVod2Result>({
        queryKey: [endpoint, videoUrl, 'video2'],
        retry: false,
        staleTime: Infinity,
        queryFn: async () => {

            const response = await fetch(`/api/${endpoint}?url=${encodeURIComponent(videoUrl)}&channelId=${channelId ?? ''}`);

            const status = response.status;

            if(!response.ok && ![404,403,429].includes(status)) {
                window.posthog?.logger.error('getKickVod2:err', {
                    videoUrl,
                    channelId,
                    status,
                    ok: response.ok,
                })
                throw new Error('Ops');
            }

            const json: KickVod2Response | null = await response.json().catch(error => {
                console.error('getKickVod2:invalid-json', {
                    videoUrl,
                    status,
                    error: String(error),
                });
                return null;
            });

            if (response.ok && !json?.video2) {
                console.error('getKickVod2:missing-video2', {videoUrl, status});
                throw new Error('Kick did not return normalized video details');
            }

            window.posthog?.logger.info('getKickVod2:ok', {
                videoUrl,
                channelId,
                json,
                status,
                ok: response.ok,
            })

            return {
                json,
                ok: response.ok,
                status
            }
        },
    });
}

export async function getKickChannelInfo(channelSlug: string) {
    return queryClient.fetchQuery({
        queryKey: ['getKickChannelInfo', channelSlug],
        retry: false,
        staleTime: Infinity,
        queryFn: async () => {

            try {
                const preservedChannelId = localStorage.getItem(`kick:channelId:${channelSlug}`);
                if(preservedChannelId && Number.isInteger(+preservedChannelId)) {
                    return +preservedChannelId;
                }
            }catch(err) {}

            try {
                const response = await fetch(`https://kick.com/api/v2/channels/${channelSlug}/info`).then(a => a.json());
                if(!Number.isInteger(response.id)) {
                    return null;
                }
                setTimeout(() => {
                    localStorage.setItem(`kick:channelId:${channelSlug}`, response.id);
                }, 0)
                return response.id
            }catch(err) {
            }
            return null;
        },
    });
}





async function _getTwitchLive(id) {
    return await fetch(`/api/get-twitch-live?channel=${id}`).then(a => a.json())
}

export const getTwitchLive = cacheWrapper(_getTwitchLive)
export const getKickLivestream = cacheWrapper(_getKickLivestream)
export const getKickClip = cacheWrapper(_getKickClip)
export const getKickVod = cacheWrapper(_getKickVod)
export const getKickClips = cacheWrapper(_getKickClips)
export const getKickPremiumVod = _getKickPremiumVod
